import { TextField } from "@mui/material"
import Btn from "../Btn"

const Subscribe = (): JSX.Element => {
    return (
        <div className="Partners middle py-20 bg-[#1C2E390D] text-center">
            <h1 className="Title text-center text-[2.5rem] font-black">
                <span className="BlackText text-black">Subscribe for</span>
                &nbsp;
                <span className="BlackText text-gold">our daily newsletter</span>
            </h1>
            <p className="text-center text-gray-500 mt-2">We'll be sending you some better deals</p>

            <div className="flex flex-col 2xs:flex-row items-center justify-center mt-6">
                <TextField
                    placeholder="your email"
                    className="noChildBorder noChildOutline rounded px-9"
                    sx={{
                        width: '90%',
                        maxWidth: '800px',
                        backgroundColor: 'white',
                    }}
                />
                <Btn noBorderRadius filled defaultStyle
                className="rounded w-[90%] 2xs:w-auto"
                >Send</Btn>
            </div>
        </div>
    )
}

export default Subscribe